
<div class="container ">
  <div class="content_container" >

    <ul>
      <h2>{{globalService.customLang.rulesTerms?.title}}</h2>
      <li>{{globalService.customLang.rulesTerms?.desc16}}</li>

      <li>{{globalService.customLang.rulesTerms?.desc1}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc2}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc3}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc4}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc5}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc6}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc7}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc8}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc9}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc10}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc11}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc12}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc13}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc14}}</li>
      <li>{{globalService.customLang.rulesTerms?.desc15}}</li>

      <h3>{{globalService.customLang.rulesTerms?.tournament_phases}}</h3>
      <h3>{{globalService.customLang.rulesTerms?.ph1}}</h3>
<!--      <p>{{globalService.customLang.rulesTerms?.ph1_desc_note}}</p>-->
      <h3>{{globalService.customLang.rulesTerms?.first_tournament}}: <span>{{globalService.customLang.rulesTerms?.first_tournament_desc}}</span></h3>
      <h3>{{globalService.customLang.rulesTerms?.second_tournament}}: <span>{{globalService.customLang.rulesTerms?.second_tournament_desc}}</span></h3>
      <h3>{{globalService.customLang.rulesTerms?.third_tournament}}: <span>{{globalService.customLang.rulesTerms?.third_tournament_desc}}</span></h3>
      <h3>{{globalService.customLang.rulesTerms?.fourth_tournament}}: <span>{{globalService.customLang.rulesTerms?.fourth_tournament_desc}}</span></h3>


      <h3>{{globalService.customLang.rulesTerms?.ph2}}</h3>

      <h3>{{globalService.customLang.rulesTerms?.registration}}</h3>

      <li>{{globalService.customLang.rulesTerms?.registration_desc1}}</li>
      <li>{{globalService.customLang.rulesTerms?.registration_desc2}}</li>
      <li>{{globalService.customLang.rulesTerms?.registration_desc3}}</li>

      <h3>{{globalService.customLang.rulesTerms?.game_setting}}</h3>
      <li>{{globalService.customLang.rulesTerms?.game_setting1}}</li>
      <li>{{globalService.customLang.rulesTerms?.game_setting2}}</li>
      <li>{{globalService.customLang.rulesTerms?.game_setting3}}</li>

      <h3>{{globalService.customLang.rulesTerms?.tournament_flow}}</h3>
      <li>{{globalService.customLang.rulesTerms?.open_tournament}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament1}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament2}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament3}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament4}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament5}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament6}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament7}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament8}}</li>
      <li>{{globalService.customLang.rulesTerms?.open_tournament9}}</li>




    </ul>
  </div>
</div>
